import { SvgIcon, SvgIconProps } from "@mui/material";

const GivenchyCheckBoxChecked = (props: SvgIconProps) => (
  <SvgIcon
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect y="1" width="15" height="15" fill="black" />
    <path d="M4 8L6.5 10.5L11 6" stroke="white" />
  </SvgIcon>
);

export default GivenchyCheckBoxChecked;
